/*
  Kundi Pets — Mini carrito en el aviso "Artículo agregado a tu carrito".

  No es un carrito paralelo: extiende el componente <cart-notification> de Dawn (cart-notification.js).
  - Al agregar un producto, Dawn pide a Shopify las secciones de getSectionsToRender() y las inyecta
    con renderContents(). Aquí solo se cambia qué parte de la sección "cart-notification-product"
    se inyecta: el bloque #kundi-mini-cart (todas las líneas + subtotal) en lugar del último artículo.
  - Eliminar una línea usa el mismo flujo que el carrito de Dawn (cart.js): /cart/change.js con
    "sections" y "sections_url", reemplazo de las secciones devueltas por Shopify (aviso, "Ver carrito (X)"
    y contador del header) y publish(PUB_SUB_EVENTS.cartUpdate) para que el resto de la página
    (p. ej. /cart o la cantidad "en el carrito" de la ficha) se sincronice.
  Todos los precios y totales vienen renderizados por Shopify; aquí no se calcula ningún importe.
*/
(function () {
  const CartNotification = customElements.get('cart-notification');
  if (!CartNotification || CartNotification.prototype.kundiMiniCart) return;
  CartNotification.prototype.kundiMiniCart = true;

  const MINI_CART_SELECTOR = '#kundi-mini-cart';
  const dawnGetSectionsToRender = CartNotification.prototype.getSectionsToRender;

  // Mismas secciones que Dawn; solo cambia el fragmento que se toma de "cart-notification-product".
  CartNotification.prototype.getSectionsToRender = function () {
    return dawnGetSectionsToRender.call(this).map((section) =>
      section.id === 'cart-notification-product' ? { id: section.id, selector: MINI_CART_SELECTOR } : section
    );
  };

  const setEmptyState = (notification) => {
    const empty = !!notification.querySelector('.kundi-mini-cart--empty');
    notification.classList.toggle('kundi-mini-cart-is-empty', empty);
  };

  // Encabezado: "Artículo agregado…" (Dawn) al agregar; "Tu carrito" al abrirlo desde el icono.
  const setHeading = (notification, fromIcon) => {
    notification.classList.toggle('kundi-mini-cart-view', fromIcon);
    const heading = notification.querySelector('.cart-notification__heading');
    if (!heading) return;
    const textNode = [...heading.childNodes].find((node) => node.nodeType === 3 && node.textContent.trim());
    if (!textNode) return;
    if (!heading.dataset.kundiAddedTitle) heading.dataset.kundiAddedTitle = textNode.textContent.trim();
    const miniCart = notification.querySelector('.kundi-mini-cart');
    const viewTitle = miniCart && miniCart.dataset.viewTitle;
    textNode.textContent = ' ' + (fromIcon && viewTitle ? viewTitle : heading.dataset.kundiAddedTitle);
  };

  const dawnRenderContents = CartNotification.prototype.renderContents;
  CartNotification.prototype.renderContents = function (parsedState) {
    dawnRenderContents.call(this, parsedState);
    setEmptyState(this.notification);
    setHeading(this.notification, !!parsedState.kundiFromIcon);
  };

  // Icono del carrito del header: abre este mismo aviso con el estado actual del carrito
  // (Section Rendering API de Shopify, mismas secciones que al agregar) en vez de ir a /cart.
  // Captura para saber si el aviso ya estaba abierto antes de que Dawn lo cierre por "clic fuera".
  document.addEventListener(
    'click',
    (event) => {
      const icon = event.target.closest('#cart-icon-bubble');
      const cartNotification = document.querySelector('cart-notification');
      if (!icon || !cartNotification || event.metaKey || event.ctrlKey || event.shiftKey || event.button > 0) return;
      event.preventDefault();

      // Si ya estaba abierto, el clic lo cierra (Dawn: clic fuera del aviso) y no se vuelve a abrir.
      if (cartNotification.notification.classList.contains('active')) return;

      const sections = cartNotification.getSectionsToRender().map((section) => section.id);
      icon.setAttribute('aria-busy', 'true');
      fetch(`${routes.cart_url}?sections=${sections.join(',')}`)
        .then((response) => response.json())
        .then((renderedSections) => {
          cartNotification.setActiveElement(icon);
          cartNotification.renderContents({ sections: renderedSections, kundiFromIcon: true });
        })
        .catch(() => {
          window.location = routes.cart_url;
        })
        .finally(() => icon.removeAttribute('aria-busy'));
    },
    true
  );

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-kundi-remove]');
    if (!button || !button.closest('#cart-notification')) return;
    event.preventDefault();

    const cartNotification = button.closest('cart-notification');
    const line = button.closest('.kundi-mini-cart__item');
    const sections = cartNotification.getSectionsToRender();
    line.classList.add('is-loading');
    button.disabled = true;

    const body = JSON.stringify({
      id: button.dataset.kundiRemove,
      quantity: 0,
      sections: sections.map((section) => section.id),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => response.json())
      .then((state) => {
        if (state.errors || state.status) throw new Error(state.errors || state.description);

        sections.forEach((section) => {
          const element = document.getElementById(section.id);
          if (element && state.sections && state.sections[section.id]) {
            element.innerHTML = cartNotification.getSectionInnerHTML(state.sections[section.id], section.selector);
          }
        });
        setEmptyState(cartNotification.notification);

        // Mantener el foco dentro del aviso tras reemplazar su contenido
        const next =
          cartNotification.notification.querySelector('[data-kundi-remove]') ||
          cartNotification.notification.querySelector('#cart-notification-button') ||
          cartNotification.notification;
        trapFocus(cartNotification.notification, next);

        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'kundi-mini-cart', cartData: state });
      })
      .catch(() => {
        line.classList.remove('is-loading');
        button.disabled = false;
        const error = document.createElement('p');
        error.className = 'kundi-mini-cart__error';
        error.setAttribute('role', 'alert');
        error.textContent = window.cartStrings ? window.cartStrings.error : 'Error';
        line.after(error);
      });
  });
})();
